export default class ListItem {
  public text: string;
  public value: string;

  constructor(text: string, value: string) {
    this.text = text;
    this.value = value;
  }
}
